import React from "react";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
// import "lightbox.js-react/dist/index.css";
import { Helmet } from "react-helmet";
import { useGetGallaryListQuery } from "../products/productSlice";
import { ImgesData } from "../home/proImgs/ImgesData";
import { useTranslation } from "react-i18next";
import gallery1 from "../../assets/img/gallery/gallery1.png";
import gallery2 from "../../assets/img/gallery/gallery2.png";
import gallery3 from "../../assets/img/gallery/gallery3.png";
import gallery4 from "../../assets/img/gallery/gallery4.png";
import gallery5 from "../../assets/img/gallery/gallery5.png";
import gallery6 from "../../assets/img/gallery/gallery6.png";
import gallery7 from "../../assets/img/gallery/gallery7.png";
import gallery8 from "../../assets/img/gallery/gallery8.png";

import gallery9 from "../../assets/img/gallery/gallery9.png";
import gallery10 from "../../assets/img/gallery/gallery10.png";
import gallery11 from "../../assets/img/gallery/gallery11.png";
import gallery12 from "../../assets/img/gallery/gallery12.png";
import gallery13 from "../../assets/img/gallery/gallery13.png";
import gallery14 from "../../assets/img/gallery/gallery14.png";
import gallery15 from "../../assets/img/gallery/gallery15.png";
import gallery16 from "../../assets/img/gallery/gallery16.png";


import galleryBig1 from "../../assets/img/gallery/gallery-1.1.png";
import galleryBig2 from "../../assets/img/gallery/gallery-1.2.png";
import galleryBig3 from "../../assets/img/gallery/gallery-1.3.png";
import galleryBig4 from "../../assets/img/gallery/gallery-1.4.png";
import galleryBig5 from "../../assets/img/gallery/gallery-1.5.png";
import galleryBig6 from "../../assets/img/gallery/gallery-1.6.png";
import galleryBig7 from "../../assets/img/gallery/gallery-1.7.png";
import galleryBig8 from "../../assets/img/gallery/gallery-1.8.png";
import galleryBig9 from "../../assets/img/gallery/gallery-1.9.png";
import galleryBig10 from "../../assets/img/gallery/gallery-1.10.png";
import galleryBig11 from "../../assets/img/gallery/gallery-2.1.png";
import galleryBig12 from "../../assets/img/gallery/gallery-2.2.png";
import galleryBig13 from "../../assets/img/gallery/gallery-2.3.png";
import galleryBig14 from "../../assets/img/gallery/gallery-2.4.png";



import newGallery1 from "../../assets/img/gallery/IMG-20251108-WA0046.jpg";
import newGallery2 from "../../assets/img/gallery/IMG-20251108-WA0047.jpg";
import newGallery3 from "../../assets/img/gallery/IMG-20251108-WA0048.jpg";
import newGallery4 from "../../assets/img/gallery/IMG-20251108-WA0049.jpg";
import newGallery5 from "../../assets/img/gallery/IMG-20251108-WA0050.jpg";
import newGallery6 from "../../assets/img/gallery/IMG-20251108-WA0052.jpg";
import newGallery7 from "../../assets/img/gallery/IMG-20251108-WA0053.jpg";
import newGallery8 from "../../assets/img/gallery/IMG-20251108-WA0055.jpg";
import newGallery9 from "../../assets/img/gallery/IMG-20251108-WA0056.jpg";
import newGallery10 from "../../assets/img/gallery/IMG-20251108-WA0057.jpg";
import newGallery11 from "../../assets/img/gallery/IMG-20251108-WA0058.jpg";
import newGallery12 from "../../assets/img/gallery/IMG-20251108-WA0059.jpg";
import newGallery13 from "../../assets/img/gallery/IMG-20251108-WA0060.jpg";
import newGallery14 from "../../assets/img/gallery/IMG-20251108-WA0061.jpg";
import newGallery15 from "../../assets/img/gallery/IMG-20251108-WA0065.jpg";
import newGallery16 from "../../assets/img/gallery/IMG-20251108-WA0066.jpg";


import trendGallery1 from "../../assets/img/gallery/IMG-20251108-WA0068.jpg";
import trendGallery2 from "../../assets/img/gallery/IMG-20251108-WA0069.jpg";
import trendGallery3 from "../../assets/img/gallery/IMG-20251108-WA0070.jpg";
import trendGallery4 from "../../assets/img/gallery/IMG-20251108-WA0071.jpg";
import trendGallery5 from "../../assets/img/gallery/IMG-20251108-WA0071.jpg";
import trendGallery6 from "../../assets/img/gallery/IMG-20251108-WA0073.jpg";
import trendGallery7 from "../../assets/img/gallery/IMG-20251108-WA0074.jpg";
import trendGallery8 from "../../assets/img/gallery/IMG-20251108-WA0075.jpg";
import trendGallery9 from "../../assets/img/gallery/IMG-20251108-WA0077.jpg";
import trendGallery10 from "../../assets/img/gallery/IMG-20251108-WA0079.jpg";
import trendGallery11 from "../../assets/img/gallery/IMG-20251108-WA0080.jpg";
import trendGallery12 from "../../assets/img/gallery/IMG-20251108-WA0081.jpg";
import trendGallery13 from "../../assets/img/gallery/IMG-20251108-WA0082.jpg";

import trendGallery14 from "../../assets/img/gallery/IMG-20251110-WA0015.jpg";
import trendGallery15 from "../../assets/img/gallery/IMG-20251110-WA0017.jpg";
import trendGallery16 from "../../assets/img/gallery/IMG-20251110-WA0019.jpg";


const galleryData = {
  new: [
    {
      id: 1,
      url: newGallery1,
    },
    {
      id: 2,
      url: newGallery2,
    },
    {
      id: 3,
      url: newGallery3,
    },
    {
      id: 4,
      url: newGallery4,
    },
    {
      id: 5,
      url: newGallery5,
    },
    {
      id: 6,
      url: newGallery6,
    },
    {
      id: 7,
      url: newGallery7,
    },
    {
      id: 8,
      url: newGallery8,
    },
    {
      id: 9,
      url: newGallery9,
    },
    {
      id: 10,
      url: newGallery10,
    },
    {
      id: 11,
      url: newGallery11,
    },
    {
      id: 12,
      url: newGallery12,
    },
    {
      id: 13,
      url: newGallery13,
    },
    {
      id: 14,
      url: newGallery14,
    },
    {
      id: 15,
      url: newGallery15,
    },
    {
      id: 16,
      url: newGallery16,
    },
  ],
  trend: [
    {
      id: 1,
      url: trendGallery1,
    },
    {
      id: 2,
      url: trendGallery2,
    },
    {
      id: 3,
      url: trendGallery3,
    },
    {
      id: 4,
      url: trendGallery4,
    },
    {
      id: 5,
      url: trendGallery5,
    },
    {
      id: 6,
      url: trendGallery6,
    },
    {
      id: 7,
      url: trendGallery7,
    },
    {
      id: 8,
      url: trendGallery8,
    },
    {
      id: 9,
      url: trendGallery9,
    },
    {
      id: 10,
      url: trendGallery10,
    },
    {
      id: 11,
      url: trendGallery11,
    },
    {
      id: 12,
      url: trendGallery12,
    },
    {
      id: 13,
      url: trendGallery13,
    },
    {
      id: 14,
      url: trendGallery14,
    },
    {
      id: 15,
      url: trendGallery15,
    },
    {
      id: 16,
      url: trendGallery16,
    },
  ],
  primary: [
    {
      id: 1,
      url: gallery1,
    },
    {
      id: 2,
      url: gallery2,
    },
    {
      id: 3,
      url: gallery3,
    },
    {
      id: 4,
      url: gallery4,
    },
    {
      id: 5,
      url: gallery5,
    },
    {
      id: 6,
      url: gallery6,
    },
    {
      id: 7,
      url: gallery7,
    },
    {
      id: 8,
      url: gallery8,
    },
    {
      id: 9,
      url: gallery9,
    },
    {
      id: 10,
      url: gallery10,
    },
    {
      id: 11,
      url: gallery11,
    },
    {
      id: 12,
      url: gallery12,
    },
    {
      id: 13,
      url: gallery13,
    },
    {
      id: 14,
      url: gallery14,
    },
    {
      id: 15,
      url: gallery15,
    },
    {
      id: 16,
      url: gallery16,
    },
  ],
  secondary: [
    {
      id: 1,
      url: galleryBig1,
    },
    {
      id: 2,
      url: galleryBig2,
    },
    {
      id: 3,
      url: galleryBig3,
    },
    {
      id: 4,
      url: galleryBig4,
    },
    {
      id: 5,
      url: galleryBig5,
    },
    {
      id: 6,
      url: galleryBig6,
    },
    {
      id: 7,
      url: galleryBig7,
    },
    {
      id: 8,
      url: galleryBig8,
    },
    {
      id: 9,
      url: galleryBig9,
    },
    {
      id: 10,
      url: galleryBig10,
    },
    {
      id: 11,
      url: galleryBig11,
    },
    {
      id: 12,
      url: galleryBig12,
    },
    {
      id: 13,
      url: galleryBig13,
    },
    {
      id: 14,
      url: galleryBig14,
    },
    
  ],
};
function PhotoGallery() {
  const { data, isLoading } = useGetGallaryListQuery();

  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Photo Gallery | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title="Photo Gallery" t={t} />
      <section className="photoGallery sectionPD">
        <div className="container">
          {isLoading && (
            <div className="preloaderCount">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          {/* Gallery */}
          <div className="row">
            <div className="col-lg-12 col-md-12 mb-4 mb-lg-0">
              <div className="fisherman-content">
                <h6>Project Snapshot</h6>
                <h3>Our Photo Gallery</h3>
              </div>
            </div>
            
            {/* Gallery */}
            {galleryData.new.map((item) => {
              return (
                <div className="col-lg-6 col-6" key={item.id}>
                  <div className="galleryCard mb-3">
                    <img src={item.url} alt="Gallery" className="img-fluid" />
                  </div>
                </div>
              );
            })}
            <hr />
            {galleryData.trend.map((item) => {
              return (
                <div className="col-lg-6 col-6" key={item.id}>
                  <div className="galleryCard mb-3">
                    <img src={item.url} alt="Gallery" className="img-fluid" />
                  </div>
                </div>
              );
            })}

          <hr />
            {galleryData.primary.map((item) => {
              return (
                <div className="col-lg-4 col-md-4 col-sm-6 col-6" key={item.id}>
                  <div className="galleryCard mb-3">
                    <img src={item.url} alt="Gallery" className="img-fluid" />
                  </div>
                </div>
              );
            })}

            <div className="col-lg-12 col-md-12 mb-4 mb-lg-0">
              <div className="fisherman-content mt-4">
                <h6>Project Snapshot</h6>
                <h3>PAST PROJECTS SNAPSHOTS</h3>
              </div>
            </div>
            
            {galleryData.secondary.map((item) => {
              return (
                <div className="col-lg-4 col-md-4 col-sm-6 col-6" key={item.id}>
                  <div className="galleryCard mb-3">
                    <img src={item.url} alt="Gallery" className="img-fluid" />
                  </div>
                </div>
              );
            })}
            {/* <div className="row">
              {data &&
                data.map((item, i) => {
                  return (
                    <div
                      className="col-lg-3"
                      key={item._id}
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModalPhoto"
                    >
                      <img
                        style={{ width: "100%" }}
                        src={ImgesData[i].url}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="Fertilizer"
                      />
                    </div>
                  );
                })}
            </div> */}
            {/* Gallery */}
          </div>

          {/* <div
            className="modal fade exampleModalPhoto"
            id="exampleModalPhoto"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <img src={ImgesData[0].url} />
                <div id="carouselExampleIndicators" className="carousel slide">
                  <div className="carousel-inner">
                    <div
                      style={{ borderTop: "2px solid gray" }}
                      className="carousel-item active"
                    >
                      <img src={ImgesData[0].url} />
                    </div>
                    <div className="carousel-item">
                      <img src={ImgesData[0].url} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
}

export default PhotoGallery;
